import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BaseButton, useIsMobile } from '@repo/common';

const EmptyMvp = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  return (
    <div
      className='flex flex-col justify-center items-center w-full py-6 tabletH:p-6 h-[127px] tabletH:h-[208px] bg-transparent tabletH:bg-grayscale-gray00 
      gap-3 tabletH:gap-2.5 rounded-[15px]'
    >
      <div className='flex flex-col items-center w-full gap-0.5 tabletH:gap-0 pb-3 tabletH:pb-4'>
        <div className='typo-b14 tabletH:typo-b18Strong text-text-secondary'>
          No MVP stamps yet
        </div>
        <div className='typo-b11 tabletH:typo-b14 text-text-placeholder'>
          Stand out and collect MVPs awarded to top participants.
        </div>
      </div>
      <BaseButton
        size={isMobile ? 's' : 'm'}
        hideIcon
        onClick={() => navigate('/community/kpathport/pathfeed?step=01')}
      >
        Explore Workshops
      </BaseButton>
    </div>
  );
};

export default EmptyMvp;
